export default __webpack_public_path__ + "static/media/pte_4.575d2ea7.png";